import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, X, ChevronRight } from "lucide-react";
import { api } from "../lib/api";
import { lsGet, lsSet } from "../lib/safeStorage";

const DISMISS_KEY = "habano.urgent.guest.session";

/**
 * Shown only to customers when an active Urgent / Customs / Currency update exists
 * and the customer hasn't dismissed it for this session. Auto-hides once the user
 * signs in (parent passes `user` and skips render).
 */
export default function GuestUrgentBanner() {
  const [update, setUpdate] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(DISMISS_KEY) === "1"; } catch { return lsGet(DISMISS_KEY) === "1"; }
  });

  useEffect(() => {
    api.get("/updates/urgent-guest")
      .then(({ data }) => { if (data && data.id) setUpdate(data); })
      .catch(() => {});
  }, []);

  if (!update || dismissed) return null;
  const title = (update.headline || {}).en || (update.headline || {}).es || "";
  const cat = update.category || "Urgent";

  const dismiss = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch { lsSet(DISMISS_KEY, "1"); }
    setDismissed(true);
  };

  return (
    <div className="px-6 mt-3" data-testid="guest-urgent-banner">
      <Link
        to={`/updates/${update.id}`}
        className="flex items-center gap-3 px-4 py-3 border-l-[3px] relative"
        style={{ background: "#171717", borderLeftColor: "#F59E0B", minHeight: 56 }}
      >
        <AlertTriangle className="w-4 h-4 text-amber-300 shrink-0" strokeWidth={1.6} />
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-amber-300 mb-0.5">{cat}</div>
          <div className="font-display text-base text-foreground leading-snug truncate" data-testid="guest-urgent-headline">
            {title}
          </div>
        </div>
        <span className="inline-flex items-center gap-1 text-[11px] uppercase tracking-widest text-gold pr-8 shrink-0">
          See all updates <ChevronRight className="w-3 h-3" strokeWidth={1.5} />
        </span>
        <button
          type="button"
          aria-label="Dismiss"
          data-testid="guest-urgent-dismiss"
          onClick={dismiss}
          className="absolute top-1 right-1 w-9 h-9 grid place-items-center text-foreground/55 hover:text-foreground"
        >
          <X className="w-4 h-4" strokeWidth={1.5} />
        </button>
      </Link>
    </div>
  );
}
